export default "/images/vendor/flag-icon-css/flags/4x3/no.svg?6df96bb22557028a5f7728dd629bfdef";